module.exports = __webpack_public_path__ + "static/img/s25.c8e41df3.png";